import { makeStyles } from '@material-ui/core/styles';

const scheduleAssemblyStyles = makeStyles(({ breakpoints }) => ({
  productListBox: {
    margin: '24px 0px',
    padding: '8px 0 26px 16px',
    flexDirection: 'column',
    background: '#f3f3f3',
    borderRadius: '8px',
    [breakpoints.down('xs')]: {
      padding: '8px 16px 26px 16px',
    },
  },
  customerDataBox: {
    paddingLeft: '24px',
    marginTop: '24px',
    [breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '0',
    },
  },
}));

export { scheduleAssemblyStyles };
